import React, { useState, useEffect, useRef } from "react";
import { Menu, ShoppingCart, ChevronDown, LogOut } from "lucide-react";
import { useAuthStore } from "../../../store/useAuthStore";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useProductStore } from "../../../store/useProductStore";
import ProductModal from "../../../pages/Product/ProductModal";
import ConfirmDialog from "../../Dialog/ConfirmDialog";

const Header = ({ onMenuClick }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dialogVisible, setIsDialogVisible] = useState(false);

  const { logout, user } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const profileRef = useRef(null);
  const dropdownRef = useRef(null);

  const userData = user?.userDataObj;
  const cartCount = useProductStore((state) => state.cartCount);

  useEffect(() => {
    setIsProfileOpen(false);
  }, [location]);

  const handleCartClick = () => {
    setIsModalOpen(true);
  };

  const handleLogout = () => {
    logout();
    setIsProfileOpen(false);
    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileRef.current && 
        dropdownRef.current &&
        !profileRef.current.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-10">
      <div className="max-w-full px-4">
        <div className="flex items-center justify-end h-16">
          <div className="flex items-center gap-4">
            {/* <div className="relative cursor-pointer" onClick={handleCartClick}>
              <ShoppingCart className="h-6 w-6 text-gray-500" />
              <span className="absolute -top-2 -right-2 bg-emerald-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {cartCount}
              </span>
            </div> */}

            <div
              ref={profileRef}
              className="flex items-center gap-2 cursor-pointer relative"
              onClick={() => {
                setIsProfileOpen(!isProfileOpen);
              }}
            >
              <img
                src="https://www.shutterstock.com/image-vector/user-profile-icon-vector-avatar-600nw-2247726673.jpg"
                alt="User"
                className="h-8 w-8 rounded-full"
              />
              <span className="text-gray-700">
                {userData?.firstName} {userData?.lastName}
              </span>
              <ChevronDown size={16} className="text-gray-400" />
            </div>
          </div>
        </div>

        {isProfileOpen && (
          <div 
          ref={dropdownRef}
          className="absolute right-0 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
            <button
              onClick={() => setIsDialogVisible(true)}
              className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 w-full cursor-pointer"
            >
              <LogOut className="h-4 w-4" />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>

      {isModalOpen && <ProductModal closeModal={() => setIsModalOpen(false)} />}

        <ConfirmDialog 
          isOpen={dialogVisible}
          setIsOpen={setIsDialogVisible}
          handler={handleLogout}
          title='Confirmation'
          message="Are you sure you want to Logout ?"
          color="red"
        />
    </header>
  );
};

export default Header;